var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":_vm.$t('general.doctor'),"prepend-inner-icon":"fa-user-md","items":_vm.items,"item-text":"name","item-value":"$id","solo":"","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }